import { useAtom } from 'jotai';
import { IAppLink } from '../../../types/global';
import { currentPageIdAtom } from '../appState.atoms';

// This hook is used to get the currentPageId from the currentPageIdAtom
export default function useCurrentPageId(): [IAppLink['id'] | null] {
	const [currentPageId] = useAtom(currentPageIdAtom);

	return [currentPageId];
}
